import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 108	分支选项内容
 */

export default class EventTextChoice extends EventBase {
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '']
  }
  /**
   * 时间ID
   */
  Code = EventID.TextChoice

  // #region 类的相关绑定参数都在这里
  /**
   * 分支选项位置
   */
  get ChoicePos() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set ChoicePos(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 分之选项内容
   */
  get Content() {
    return this.Parameter?.[1] ?? ''
  }
  set Content(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  setLocalesParam(indexes: number[]): void {
    indexes = [1]
    super.setLocalesParam(indexes)
  }
}
